import { Button, Modal, Stack, Text } from "@assetwatch/ui";
import { displayWorkOrderNumber } from "../snowflakes/work-orders/presentation";

export function DeleteWorkOrderModal({
  open,
  number,
  error,
  isPending,
  onOpenChange,
  onDelete,
}: {
  open: boolean;
  number: string;
  error: string | null;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => Promise<void>;
}) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={`Delete ${displayWorkOrderNumber(number)}`}
      size="md"
    >
      <Stack gap={16}>
        <Text>
          Deleting this Work Order removes it from ordinary views and declines
          its linked Approved Request. Its attachments, Procedure execution, and
          history are retained for authorized deleted-record access.
        </Text>
        {error ? <Text tone="negative">{error}</Text> : null}
        <div className="flex justify-end gap-(--spacing-8)">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Keep Work Order
          </Button>
          <Button
            disabled={isPending}
            loading={isPending}
            loadingText="Deleting"
            onClick={() => void onDelete().catch(() => undefined)}
          >
            Delete Work Order
          </Button>
        </div>
      </Stack>
    </Modal>
  );
}
